import { matchPath } from "react-router-dom";

import { Link } from "common/types/routing";

import { ROUTES } from "routing/routes";

export function isInTeacherPlatform(pathname: Link) {
  const stringpath =
    // @ts-ignore
    typeof pathname === "string" ? pathname : pathname.pathname;

  if (!stringpath) {
    return false;
  }

  return matchPath(stringpath, {
    path: ROUTES.TEACHER.buildPath({}),
    exact: false
  });
}
